import { useEffect } from 'react';

import { TraceLog } from '../../../data/misc';

// In order to avoid listening to object changes in useEffect,
// we instead store these trace logs outside of React in a singleton.
// Then, when the user switches to dataset mode, we can access the trace logs
// even if they come from a subgraph deeply within React's component tree.
export const GraphDatasetTraceLogStore = (() => {
  const store: Record<string, TraceLog[]> = {};

  return {
    getAll() {
      return store;
    },
    set(namespace: string, traceLog: TraceLog[] | null) {
      if (!traceLog) {
        delete store[namespace];
      } else {
        store[namespace] = traceLog;
      }
    },
  };
})();

export const useRegisterTraceLogToDatasetStore = (
  namespace: string | '$',
  traceLog: TraceLog[] | null
) => {
  useEffect(() => {
    GraphDatasetTraceLogStore.set(namespace, traceLog);
    return () => void GraphDatasetTraceLogStore.set(namespace, null);
  }, [traceLog, namespace]);
};
